import { createAction } from 'redux-actions'
import {
  getNextSourceSetupStep,
  getActiveWorkspace,
  getSourceSetupSlug,
  getMetadataByTypeAndSlug
} from 'selectors'

export const RESET_SOURCE_SETUP = 'RESET_SOURCE_SETUP'
export const SET_SOURCE_SETUP_STEP = 'SET_SOURCE_SETUP_STEP'
export const UPDATE_SOURCE_SETUP_SOURCE = 'UPDATE_SOURCE_SETUP_SOURCE'

export const resetSourceSetup = createAction(RESET_SOURCE_SETUP)
export const setSourceSetupStep = createAction(SET_SOURCE_SETUP_STEP)
export const updateSourceSetupSource = createAction(UPDATE_SOURCE_SETUP_SOURCE)

export const nextSourceSetupStep = () => (dispatch, getState) => {
  const state = getState()
  const nextStep = getNextSourceSetupStep(state)
  dispatch(setSourceSetupStep(nextStep))
}

export const trackSourceAuthorizeClicked = () => (dispatch, getState) => {
  const state = getState()
  const workspace = getActiveWorkspace(state)
  const sourceSlug = getSourceSetupSlug(state)
  const { data: sourceMetadata = {} } = getMetadataByTypeAndSlug(state, 'source', sourceSlug) || {}

  window.analytics.track('Source Authorize Clicked', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_metadata_slug: sourceMetadata.slug,
    source_metadata_category: sourceMetadata.category,
    funnel_step: 'Source Authorize Clicked'
  })
}

export const trackSourceSetupFunnelStepCompleted = ({ step, error, ctaText }) => (dispatch, getState) => {
  const state = getState()
  const workspace = getActiveWorkspace(state)
  const sourceSlug = getSourceSetupSlug(state)
  const { data: sourceMetadata = {} } = getMetadataByTypeAndSlug(state, 'source', sourceSlug) || {}

  const properties = {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_metadata_slug: sourceMetadata.slug,
    source_metadata_category: sourceMetadata.category,
    funnel_step: step,
    cta_text: ctaText
  }

  if (error) {
    properties.error_level = error.level
    properties.error_reason = error.reason
    properties.error_message = error.message
  }

  window.analytics.track('Source Setup Funnel Step Completed', properties)
}



// WEBPACK FOOTER //
// ./actions/source-setup.js